<template>
  <div class="p-2 sm:py-4 min-h-slideover" :class="[newNotification.cliente ? 'bg-white' : 'bg-secundario']">
    <div v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])" class="mb-2 flex justify-between">
      <div class="flex w-full">
        <button
          @click="newNotification.cliente = true"
          class="inline-flex justify-center items-center w-full py-2 px-4 space-x-2 rounded focus:outline-none"
          :class="[newNotification.cliente ? 'text-white bg-azul' : 'text-white bg-secundario']"
        >
          <!-- === CLIENT ICON === -->
          <svg class="w-6 h-6 fill-current" viewBox="0 0 64 64">
            <path d="M48.86 41.1c-1.66-2.1-3.63-3.76-5.96-5.06 5.19-3.4 8.6-9.27 8.6-15.9C51.46 9.66 42.9 1.11 32.47 1.2c-10.44.09-18.99 8.6-18.99 19.03 0 6.63 3.4 12.45 8.55 15.81-.04 0-.13.04-.18.04-.72.45-1.43.85-2.1 1.39-4.66 3.54-7.17 8.28-8.28 13.93-.13.72 0 1.16.45 1.7.67.72 1.3 1.43 1.97 2.1.72-1.79 2.51-5.78 3.63-6.81 1.16-1.16-1.84 5.37-2.64 7.75 1.93 1.66 3.94 3.09 6.22 4.21 3.54 1.7 7.17 2.64 11.02 2.64l-3.99-5.46 2.06-11.96-2.06-3.31 1.39-1.93c-.94-.18-1.88-.49-2.78-.9-1.57-.72-3-1.79-4.21-3 2.87 1.79 6.31 2.82 9.99 2.82 3.63 0 7.03-1.03 9.85-2.82-2.02 2.02-4.34 3.31-7.03 3.94l1.43 1.93-2.06 3.31 2.06 11.96-3.99 5.37c.54 0 1.07-.04 1.61-.09 2.87-.18 5.73-.94 8.33-2.1 2.42-1.12 4.66-2.51 6.63-4.21-.4-1.7-4.08-9.54-2.78-8.28 1.16 1.25 3.27 6.05 3.81 7.34 1.03-.99 2.02-1.97 2.96-3.09.04-.13.13-.31.13-.45-.58-4.02-2.01-7.69-4.61-10.96z" />
          </svg>
          <span class="text-sm uppercase font-semibold">{{ $t('lang.msg.client') }}</span>
        </button>
        <button
          @click="newNotification.cliente = false"
          class="inline-flex justify-center items-center w-full py-2 px-4 space-x-2 rounded focus:outline-none"
          :class="[!newNotification.cliente ? 'text-white bg-azul' : 'text-azul bg-white']"
        >
          <!-- === FACTORY ICON === -->
          <svg class="w-6 h-6 fill-current" viewBox="0 0 64 64">
            <path d="M63.14 57.2l-.04-12.64V7.94c0-.27-.09-.54-.18-.76-.14-.18-.31-.31-.49-.31H50.96c-.18 0-.36.13-.49.31s-.18.45-.18.76v24.03L25.94 13.43c-.22-.18-.49-.18-.71-.09-.22.13-.4.36-.4.63v16.88L1.96 13.43c-.18-.13-.45-.18-.71-.04-.22.13-.4.36-.4.63v43.32c0 .18.09.36.22.49s.31.17.49.17h60.91c.22 0 .4-.09.54-.22.09-.18.18-.41.13-.58zM17.28 37.59c0 .18-.04.31-.18.4-.13.13-.27.18-.4.18H7.81c-.18 0-.31-.04-.4-.18-.09-.09-.18-.27-.18-.4V35c0-.13.04-.31.18-.4.09-.09.27-.18.4-.18h8.89c.18 0 .31.04.4.18.13.09.18.27.18.4v2.59zm23.89 0c0 .18-.04.31-.18.4-.13.13-.27.18-.4.18H31.7c-.18 0-.31-.04-.4-.18-.13-.09-.18-.27-.18-.4V35c0-.13.04-.31.18-.4.09-.09.27-.18.4-.18h8.89c.18 0 .31.04.4.18.09.09.18.27.18.4v2.59z" />
          </svg>
          <span class="text-sm uppercase font-semibold">{{ $t('lang.msg.factory') }}</span>
        </button>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-2 mb-2">
      <InputWrapper :label="$t('lang.msg.internalReference')" block>
        <router-link
          v-if="hasRoles(['DIRECCIÓN', 'ADMIN', 'EQUIPO EUROPROSEM'])"
          :to="{ name: 'sample', params: { idSample: extraParams.sample.idSample } }"
          class="text-sm text-blue-700 font-semibold tracking-wide"
        >
          {{ extraParams.sample.comercialRequestReference }} {{ extraParams.sample.comercialRequestReferenceNumber }}
        </router-link>
        <span v-else>
          {{ extraParams.sample.comercialRequestReference }} {{ extraParams.sample.comercialRequestReferenceNumber }}
        </span>
      </InputWrapper>
      <InputWrapper :label="$t('lang.msg.clientReference')" block>
        <span>{{ extraParams.sample.comercialRequestClientReference|default }}</span>
      </InputWrapper>
      <InputWrapper :label="$t('lang.msg.collection')" block>
        <span>{{ getLangValue(extraParams, "collection") }}</span>
      </InputWrapper>
    </div>

    <textarea
      v-model="newNotification.comentario"
      :placeholder="$t('lang.msg.writeNote')"
      class="form-textarea w-full"
    />
    <div class="flex items-center justify-end">
      <ButtonAction @action="saveNotification" class="my-3">
        {{ $t("lang.msg.sendNote") }}
      </ButtonAction>
    </div>

    <!-- ============================== -->
    <!-- === PREVIOUS NOTIFICATIONS === -->
    <!-- ============================== -->
    <h2
      v-if="user.rol != 'CLIENTE' && user.rol != 'FÁBRICA'"
      class="text-lg font-semibold mb-3 pb-1 border-b"
      :class="[newNotification.cliente ? 'text-primario' : 'text-white']"
    >
      {{ this.newNotification.cliente ? $t("lang.msg.previousClientNotes") : $t("lang.msg.previousFactoryNotes") }}
    </h2>
    <h2 v-else class="text-lg text-primario font-semibold mb-3 pb-1 border-b">
      {{ $t("lang.msg.previousNotes") }}
    </h2>
    <div v-if="notifications">
      <div class="flex flex-col space-y-2">
        <NotificationItem
          v-for="(item, index) in notifications"
          :key="`item_${index}`"
          :item="item"
          :hidden="index >= 2"
          :show-all-notifications="showAllNotifications"
          :is-client="newNotification.cliente"
        />
      </div>

      <ExpandableButton
        :length="notifications.length"
        :max-length="2"
        @click="showAllNotifications = !showAllNotifications"
      />
    </div>
    <span v-else>{{ $t("lang.msg.resultsNotFound") }}</span>
  </div>
</template>

<script>
import NotificationItem from "@/components/NotificationItem";
export default {
  name: "Notifications",
  emits: ['note-added', 'client-changed'],
  props: {
    extraParams: {
      type: Object,
      default: () => {}
    },
    notifications: {
      type: [Array, Object],
      default: () => []
    }
  },
  components: {
    NotificationItem
  },
  data() {
    return {
      showAllNotifications: false,
      newNotification: {}
    };
  },
  methods: {
    resetNotification(afterComment) {
      this.newNotification = {
        cliente:
          afterComment ? this.newNotification.cliente : this.extraParams.cliente,
        comentario: "",
        rol: this.user.rol,
        idUser: this.user.id,
        idSample: this.extraParams.sample.idSample,
        idFactory: this.extraParams.idFactory,
        referencia: this.extraParams.referencia
      };
    },
    saveNotification() {
      if (this.newNotification.comentario != "") {
        this.$axios
          .post("api/Notificaciones/AddComentario", this.newNotification)
          .then(() => {
            this.$emit("note-added", this.newNotification);
            this.resetNotification(true);
          });
      }
    }
  },
  computed: {
    clientRadioButton() {
      return this.newNotification.cliente;
    }
  },
  watch: {
    extraParams() {
      this.resetNotification(false);
    },
    clientRadioButton() {
      this.$emit("client-changed", {
        sample: this.extraParams.sample,
        cliente: this.clientRadioButton
      });
    }
  }
};
</script>
